import { combineEpics } from 'redux-observable';
import { onCoverageRulesRejectedEpic } from './_epics/onCoverageRulesRejected.epic';
import { onLoadCoverageRulesDoneEpic } from './_epics/onLoadCoverageRulesDone.epic';
import { onUpdateCoverageRulesDoneEpic } from './_epics/onUpdateCoverageRulesDone.epic';
import { onValidateCoverageRulesDoneEpic } from './_epics/onValidateCoverageRulesDone.epic';
import { validateCoverageRulesEpic } from './_epics/validateCoverageRules.epic';

export const controllerCoverageRulesEpic = combineEpics(
  onCoverageRulesRejectedEpic,
  onLoadCoverageRulesDoneEpic,
  onUpdateCoverageRulesDoneEpic,
  onValidateCoverageRulesDoneEpic,
  validateCoverageRulesEpic,
);
